import { useState, useCallback } from 'react';

const useBodyOverflow = () => {
  const [overflowValue, setOverflowValue] = useState(null);
  const setBodyOverflow = useCallback(value => {
    const { overflow } = document.body.style;

    setOverflowValue(overflow);
    document.body.style.overflow = value;
  }, []);
  const releaseBodyOverflow = useCallback(() => {
    document.body.style.overflow = overflowValue;
  }, []);

  return {
    setBodyOverflow,
    releaseBodyOverflow,
  };
};

export default useBodyOverflow;
